import { RouteRecordRaw } from 'vue-router'

export const secondaryAttentionRoutes: RouteRecordRaw[] = [
  {
    path: '/matriciamento',
    name: 'matriciamento',
    component: () =>
      /* webpackChunkName: "SecondOpinionView" */
      import('@/views/SecondOpinionView.vue'),
    meta: {
      onlyLoggedIn: true,
      title: 'Opinião de especialista'
    },
    children: [
      {
        path: '/matriciamento/perguntas',
        name: 'matriciamento-listagem-perguntas',
        component: () =>
          /* webpackChunkName: "SecondOpinion" */
          import('@/components/secondOpinion/organisms/SecondOpinion.vue'),
        meta: {
          onlyLoggedIn: true,
          title: 'Opinião de especialista'
        }
      },
      {
        path: '/matriciamento/perguntas/:id',
        name: 'pergunta-matriciamento',
        component: () =>
          /* webpackChunkName: "SecondOpinionQuestion" */
          import(
            '@/components/secondOpinion/organisms/SecondOpinionQuestion.vue'
          ),
        props: true,
        meta: {
          onlyLoggedIn: true,
          title: 'Opinião de especialista'
        }
      }
    ],
    redirect: '/matriciamento/perguntas'
  }
]
